import type { Item } from '@inno-sdks/files'
import type { AppId } from '@inno-tools/container-bridge'
import type { SystemShortcutPresentation } from 'shared/types/desktop-grid'

export type SystemShortcutAction =
  | 'openSupport'
  | 'openNewGrantApplication'
  | 'openMyBills'

export type SystemShortcutDefinition = {
  key: string
  name: string
  shortcutUrl: string
  displayNameKey?: string
  iconAppId?: AppId
  action?: SystemShortcutAction
  /** The action keeps its tile busy until it emits a lifecycle completion event. */
  requiresLoadingState?: boolean
  deepLink?: {
    matches: (value: string) => boolean
    consumedSearchParams: readonly string[]
  }
  presentation: SystemShortcutPresentation
  matches: (item: Item) => boolean
}

export type SystemShortcutConfig = Omit<SystemShortcutDefinition, 'matches'>
